var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountVerification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2684",
    "data-name": "Rectangle 2684",
    width: 60,
    height: 60,
    transform: "translate(554 5446)",
    fill: "#e6e8f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "account_verification",
    "data-name": "account verification",
    transform: "translate(-554 -5446)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11536",
    "data-name": "Group 11536",
    transform: "translate(569.103 5459.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11212",
    "data-name": "Group 11212",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21825",
    "data-name": "Path 21825",
    d: "M273.074,278.7a15.266,15.266,0,1,1,30.532,0",
    transform: "translate(-273.074 -248.245)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1742",
    "data-name": "Ellipse 1742",
    cx: 6.631,
    cy: 6.631,
    r: 6.631,
    transform: "translate(8.636 0)",
    fill: "#ffb063"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_22049",
    "data-name": "Path 22049",
    transform: "translate(586.069 5479.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_22050",
    "data-name": "Path 22050",
    transform: "translate(-296.344 -389.576)",
    fill: "#102d6f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 304.1909790039062 405.3153381347656 L 303.4838562011719 404.6086730957031 L 295.6373291015625 396.7672119140625 L 294.929931640625 396.0602722167969 L 295.6369323730469 395.3529357910156 L 297.8311767578125 393.1576843261719 L 298.5380859375 392.450439453125 L 299.245361328125 393.1573181152344 L 304.1895751953125 398.0988464355469 L 313.4198303222656 388.8690490722656 L 314.126953125 388.1619567871094 L 314.8340454101562 388.8690490722656 L 317.0282287597656 391.0632934570312 L 317.7353210449219 391.7703857421875 L 317.0282592773438 392.4774780273438 L 304.8978576660156 404.6084289550781 L 304.1909790039062 405.3153381347656 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 304.1907348632812 403.9013366699219 L 316.3211364746094 391.7703857421875 L 314.1269226074219 389.576171875 L 304.1897277832031 399.5128479003906 L 298.5384521484375 393.8646240234375 L 296.3442077636719 396.0598754882812 L 304.1907348632812 403.9013366699219 M 304.1912231445312 406.7293395996094 L 293.5156555175781 396.0606689453125 L 298.5377502441406 391.0362548828125 L 304.1893920898438 396.6848449707031 L 314.126953125 386.7477722167969 L 319.1495361328125 391.7703552246094 L 304.1912231445312 406.7293395996094 Z",
    stroke: "none",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountVerification);
export default __webpack_public_path__ + "static/media/account_verification.be50163689a24e9ccc7410b395fde7ad.svg";
export { ForwardRef as ReactComponent };